/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createImageWatermarkPresetResponseFromDiscriminatorValue, createPaginatedResultOfImageWatermarkPresetResponseFromDiscriminatorValue, serializeCreateImageWatermarkPresetRequest, serializeImageWatermarkPresetResponse, type CreateImageWatermarkPresetRequest, type HttpValidationProblemDetails, type IError, type ImageWatermarkPresetResponse, type PaginatedResultOfImageWatermarkPresetResponse } from '../models/index.js';
// @ts-ignore
import { type WithPresetItemRequestBuilder, WithPresetItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /image-watermark-presets
 */
export interface ImageWatermarkPresetsRequestBuilder extends BaseRequestBuilder<ImageWatermarkPresetsRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.imageWatermarkPresets.item collection
     * @param presetId Unique identifier of the item
     * @returns {WithPresetItemRequestBuilder}
     */
     byPresetId(presetId: Guid) : WithPresetItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfImageWatermarkPresetResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ImageWatermarkPresetsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfImageWatermarkPresetResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ImageWatermarkPresetResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: CreateImageWatermarkPresetRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ImageWatermarkPresetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ImageWatermarkPresetsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateImageWatermarkPresetRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface ImageWatermarkPresetsRequestBuilderGetQueryParameters {
    imageWatermarkId?: Guid;
    page?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const ImageWatermarkPresetsRequestBuilderUriTemplate = "{+baseurl}/image-watermark-presets{?imageWatermarkId*,page*,pageSize*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ImageWatermarkPresetsRequestBuilderNavigationMetadata: Record<Exclude<keyof ImageWatermarkPresetsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byPresetId: {
        requestsMetadata: WithPresetItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["presetId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ImageWatermarkPresetsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ImageWatermarkPresetsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfImageWatermarkPresetResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: ImageWatermarkPresetsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createImageWatermarkPresetResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateImageWatermarkPresetRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
